import React from "react";

export default function About() {
  const values = [
    { icon: "🤝", title: "Trust", desc: "We build lasting relationships with clients through transparency and reliability." },
    { icon: "🏆", title: "Excellence", desc: "Every shipment is handled with precision, care, and attention to detail." },
    { icon: "🚀", title: "Innovation", desc: "We leverage cutting-edge technology to optimize logistics and reduce lead times." },
    { icon: "🌍", title: "Cultural Resonance", desc: "We understand the unique needs of diverse markets and communities." }
  ];

  return (
    <section id="about" className="about">
      <h2>About Us</h2>
      
      <div className="about-intro">
        <p>
          At AROCL Customs Solutions, we don't just move cargo—we build trust, efficiency, and cultural resonance into every shipment. With years of expertise in international logistics, customs clearance, warehousing, and specialized cargo handling, we've become a trusted partner for businesses seeking seamless supply chain solutions.
        </p>
      </div>

      <div className="about-mission about-card">
        <h3>
          <span className="about-section-icon">🎯</span>
          Our Mission
        </h3>
        <p>
          To provide world-class logistics and customs solutions that simplify international trade, reduce costs, and accelerate delivery—while maintaining the highest standards of compliance and customer service.
        </p>
      </div>

      <div className="about-vision about-card">
        <h3>
          <span className="about-section-icon">🌍</span>
          Our Vision
        </h3>
        <p>
          To be the leading logistics partner of choice for businesses engaging in international trade, recognized for our innovation, reliability, and commitment to connecting markets across borders with seamless, efficient, and sustainable solutions.
        </p>
      </div>

      <div className="about-values about-card">
        <h3>
          <span className="about-section-icon">💎</span>
          Our Core Values
        </h3>
        <div className="values-grid">
          {values.map((val, i) => (
            <div key={i} className="value-card">
              <span className="about-value-icon">{val.icon}</span>
              <h4>{val.title}</h4>
              <p>{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
      
    </section>
  );
}
